import { jsx } from "react/jsx-runtime";
import { useMemo, Suspense } from "react";
import { Loader } from "@perxis-auto/ui-kit/lib/components/Loader";
import { ConstructorContext } from "../../context/constructor.js";
import { useThisContext } from "../../context/this.js";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import { useSkipConstructorLayout } from "../../lib/constructor/hooks/useSkipConstructorLayout.js";
import "../../lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import { ConstructorGrid } from "../constructorGrid/ConstructorGrid.js";
import styles from "./Constructor.module.scss.js";
function Constructor({
  layout,
  widgets,
  isSubConstructor
}) {
  const data = useThisContext();
  const resolvedLayout = useSkipConstructorLayout(layout, data);
  const contextValue = useMemo(() => ({ layout: resolvedLayout, widgets }), [resolvedLayout, widgets]);
  return /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Loader, { className: styles.constructor__loader, size: "large" }), children: /* @__PURE__ */ jsx(ConstructorContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(ConstructorGrid, { isSubConstructor, layout: resolvedLayout }) }) });
}
export {
  Constructor
};
